import styled from "styled-components";
import { ContentWrapper } from "../../../styles/popup";
import { EditTournamentBottom } from "../../tournament/style/home";

export const DetailInfoPopupWrapper = styled(ContentWrapper)`
  width: 601px;
  height: 379px;
  z-index: 1000;

  > .header {
    padding: 43px 45.14px 39px 51px;
  }
`;

export const DetailBodyWrapper = styled.div`
  padding-left: 51px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 12.2px;
`;
export const DetailItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;

  > .title {
    width: 169.287px;
    color: #1a191a;
    font-family: Pretendard;
    font-size: 20.233px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;
export const EditDetailBottom = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 40px;

  > .button {
    cursor: pointer;
    padding: 17.5px 201px;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 20.233px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    border-radius: 30.35px;
    background: var(--Purple-300, #6436e7);
  }
`;
export const DetailItemInputBox = styled.div`
  width: 154px;
  height: 28px;
  border-radius: 2.698px;
  border: 0.674px solid var(--Black-200, #b7b7b7);
  background: #fff;
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  > input {
    margin-left: 8px;
    padding: 0;
    width: 100%;
    border: none;
    outline: none;
    color: #808080;
    font-family: Pretendard;
    font-size: 10.791px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;
